
import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import footerBg from '../../assets/images/footer-img.png';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        position: "relative",
        background: "#1e4d8f",
        color: "#fff",
        pt: 6,
        // pb: 10,
        overflow: "hidden",
        backgroundImage:
          `url(${footerBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* DARK OVERLAY */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: "rgba(25,70,130,0.95)",
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <Grid container spacing={6}>
          {/* ABOUT US */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              sx={{
                fontWeight: 700,
                mb: 2,
                letterSpacing: 1,
              }}
            >
              ABOUT US
            </Typography>

            <Box
              sx={{
                height: "1px",
                background: "rgba(255,255,255,0.2)",
                mb: 3,
                width: "100%",
              }}
            />

            <Typography
              sx={{
                color: "#d3d9e5",
                lineHeight: 1.8,
                fontSize: "14px",
              }}
            >
              No matter how expensive a house you own or how much salary you
              get, nothing can offer more pleasure and satisfaction than a
              wonderful vacation with family and friends. We all want to
              rejuvenate ourselves by conducting multiple vacations to get rid
              of our dull and dreary life.
            </Typography>


          </Grid>

          {/* CONTACT */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              sx={{
                fontWeight: 700,
                mb: 2,
                letterSpacing: 1,
              }}
            >
              CONTACT NOW
            </Typography>

            <Box
              sx={{
                height: "1px",
                borderBottom: "1px dashed rgba(255,255,255,0.3)",
                mb: 3,
              }}
            />

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* MAIL */}
              <Box sx={{ display: "flex", gap: 1 }}>
                <EmailIcon sx={{ color: "#f5c242" }} />
                <Typography sx={{ fontSize: "14px" }}>
                  Mail : 9535681900 / 7019927779
                </Typography>
              </Box>

              {/* ADDRESS */}
              <Box sx={{ display: "flex", gap: 1 }}>
                <LocationOnIcon sx={{ color: "#f5c242" }} />
                <Typography sx={{ fontSize: "14px", lineHeight: 1.6 }}>
                  Adress : #78, Nishanth shelters, Hosur main road,
                  Madiwala, Blore 68. (Next to The Grand Krishna Hotel)
                </Typography>
              </Box>

              {/* PHONE */}
              <Box sx={{ display: "flex", gap: 1 }}>
                <PhoneIcon sx={{ color: "#f5c242" }} />
                <Typography sx={{ fontSize: "14px" }}>
                  Phone : 9535681900 / 7019927779
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "space-between", alignItems: 'center', gap: 2, mt: 4 }}>
          {/* GST BOX */}
          <Box
            sx={{
              mt: 4,
              display: "inline-block",
              background: "#4fb3df",
              color: "#fff",
              px: 3,
              py: 1,
              borderRadius: "4px",
              fontWeight: 600,
              fontSize: '14px',
              boxShadow: '0 0 0 6px rgba(255, 255, 255, 0.1)',
              '&:hover': {
                background: '#18458B',
                transition: 'all 0.3s ease',
              }

              // boxShadow: "0 0 20px rgba(79,179,223,0.5)",
            }}
          >
            GST - 29AHKPJ9280E1ZY
          </Box>

          {/* CUSTOMER SUPPORT BOX */}
          <Box
            sx={{
              // mt: 6,
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "8px",
              p: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "rgba(255,255,255,0.05)",
              backdropFilter: "blur(6px)",
              gap: 4
            }}
          >
            <Typography sx={{ fontWeight: 600 }}>
              Customer support : +91 9535681900 / +91 9535620901
            </Typography>

            <Button
              variant="contained"
              href="tel:+919535681900"
              sx={{
                background: "#f5c242",
                color: "#000",
                fontWeight: 700,
                px: 4,
                "&:hover": { background: "#e6b532" },
              }}
            >
              Call Now
            </Button>
          </Box>
        </Box>



        {/* COPYRIGHT */}

      </Container>

      {/* COPYRIGHT STRIP - EXACT MATCH */}
      <Box
        sx={{
          position: 'relative',
          width: "100%",
          background: "#061b41", // DARK BLUE (exact look)
          py: 2.5,
          mt: 6,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            sx={{
              textAlign: "left",
              fontSize: "14px",
              color: "#ffffff",
              fontWeight: 700,
            }}
          >
            Copyright © 2026 Sudarshan Holidays All Rights Reserved. | Developed by{" "}
            <span style={{ color: "#4fb3df", fontWeight: 700 }}>
              Codesight Global Solutions
            </span>{" "}
            |{" "}
            <span style={{ color: "#4fb3df", fontWeight: 700 }}>
              Bengaluru Painters
            </span>
          </Typography>
        </Container>
      </Box>

      {/* SCROLL BUTTON */}
      <IconButton
        onClick={scrollToTop}
        sx={{
          borderRadius: "10%",
          position: "fixed",
          right: 20,
          bottom: 80,
          background: "#4fb3df",
          color: "#fff",
          "&:hover": { background: "#349ac4" },
          zIndex: 9999,
        }}
      >
        <KeyboardArrowUpIcon />
      </IconButton>
    </Box>
  );
};

export default Footer;